<template>
  <div class="w-full">
    <el-form :model="updateForm" :label-position="labelPosition" :rules="rules" ref="updateForm" v-loading="loading">
      <SupplyForm :form="updateForm" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="update('updateForm')" :loading="updating">Update</el-button>
        <el-button @click="$router.back()" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import SupplyForm from './_includes/SupplyForm.vue';

export default {
  name: 'UpdateSuppliers',
  components: {
    SupplyForm,
  },
  data() {
    return {
      loading: false,
      updating: false,
      labelPosition: 'top',
      rules: this.$store.state.InventoryModule.Supplies.supply_form_validation,
    };
  },
  computed: {
    updateForm() {
      return this.$store.state.InventoryModule.Supplies.supply;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      this.loading = true;
      await this.$store.dispatch('InventoryModule/Supplies/getSupply', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
    this.loading = false;
  },
  methods: {
    update(updateForm) {
      const formData = {
        code: this.updateForm.code,
        supplier_id: this.updateForm.supplier_id,
        outlet_id: this.updateForm.outlet_id,
      };
      this.$refs[updateForm].validate(async (valid) => {
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('InventoryModule/Supplies/updateSupply', {
              supplyId: this.$route.params.id, supply: formData,
            });
            this.$notify.success({
              title: 'Success',
              message: 'Supply update was successful.',
            });
            this.$router.back();
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
